module.exports = __webpack_public_path__ + "static/media/26a.df6be963.jpg";